// Redux slice (create this in a separate file, e.g., locationSlice.ts)
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { HealthCamp } from "../../pages/guest/camp-details/campdata";

interface LocationState {
    selectedDistrict: number | null;
    selectedTaluka: number | null;
    selectedCamp: any | null;
    selectedyear: string | null;
    selectedCampType: string | null;
}

const initialState: LocationState = {
    selectedDistrict: null,
    selectedTaluka: null,
    selectedCamp: null,
    selectedyear: null,
    selectedCampType: null,
};

const dashboardFilterSlice = createSlice({
    name: "dashboardFilter",
    initialState,
    reducers: {
        setSelectedDistrict(state, action: PayloadAction<number | null>) {
            state.selectedDistrict = action.payload;
        },
        setSelectedTaluka(state, action: PayloadAction<number | null>) {
            state.selectedTaluka = action.payload;
        },
        setSelectedCamp(state, action: PayloadAction<HealthCamp | null>) {
            state.selectedCamp = action.payload;
        },
        setSelectedYear(state, action: PayloadAction<string | null>) {
            state.selectedyear = action.payload;
        },
        setSelectedCampType(state, action: PayloadAction<string | null>) {
            state.selectedCampType = action.payload;
        },
    },
});

export const { setSelectedDistrict, setSelectedTaluka, setSelectedCamp ,setSelectedYear, setSelectedCampType } = dashboardFilterSlice.actions;
export default dashboardFilterSlice.reducer;